import axios from 'axios';
import axiosConfig from 'axiosconfig';
import {
  responseInterceptor, errorInterceptor,
} from 'apiclient';

let cancel;
const { CancelToken } = axios;

const suggestRequest = axios.create(axiosConfig);
suggestRequest.interceptors.response.use(responseInterceptor, errorInterceptor);

// eslint-disable-next-line func-names
const loadSuggestion = function (keyword, languageCode) {
  if (cancel !== undefined) {
    cancel('Operation canceled; deprecated request');
  }
  return suggestRequest.get('/api/suggest', {
    cancelToken: new CancelToken(((c) => {
      cancel = c;
    })),
    params: {
      languageCode,
      mandant: process.env.CLIENTNAME,
      keyword,
    },
  })
    .then((res) => res.data)
    .catch((error) => {
      if (axios.isCancel(error)) {
        // eslint-disable-next-line no-console
        console.log('Request canceled', error.statusText.msg);
        return Promise.resolve();
      }

      return Promise.reject(error);
    });
};

export default loadSuggestion;
